<div class="card" >
  <app-header titulo="Cadastro de Classe Avaliação" descricao="Digite as informações da Classe Avaliação"></app-header>

  <div class="formgrid grid p-fluid">
        <div class="field col-4">
          <label for="classeAvaliacao">Classe Avaliação: </label>
          <input
            type="text"
            id="classeAvaliacao"
            maxlength="20"
            pInputText
            [(ngModel)]="classeAvaliacao.classeAvaliacao"
            required
          />
        </div>
        <div class="field col-4">
          <label for="contaContabil">Conta Contabil: </label>
          <input
            type="text"
            id="contaContabil"
            maxlength="20"
            pInputText
            [(ngModel)]="classeAvaliacao.contaContabil"
            required
          />
        </div>
        <div class="field col-2 pt-4">
          <button
            pButton
            icon="pi pi-save"
            class="p-button-success"
            [label]="classeAvaliacao.id ? 'Atualizar' : 'Salvar'"
            (click)="salvar()"
          ></button>
        </div>
        <div class="field col-2 pt-4">
          <button
           pButton label="Cancelar"
           icon="pi pi-times"
           class="p-button-text"
           (click)="fecharDialog()"></button>
        </div>
  </div>
</div>
